import { Vector3 as o } from "three";
import { Vectors as p } from "../../utils/index36.js";
const r = new o(), s = new o(), c = new o(), f = new o(), a = new o();
function i(u, e) {
  for (let t = 0; t < e.length - 1; t++) {
    r.fromArray(e[t]), s.fromArray(e[t + 1]), c.copy(s).sub(r).cross(p.Down), f.copy(r).add(c).sub(r);
    let n = !1;
    for (const m of u)
      if (a.fromArray(m).sub(r), a.dot(f) < 0) {
        n = !0;
        break;
      }
    if (!n)
      return !1;
  }
  return !0;
}
export {
  i as polyIntersectsConvexPoly
};
//# sourceMappingURL=index.js.map
